import { useNavigate } from "react-router-dom";
import { handleSmartBack } from "../../../../utils/navigationHelper";

const BackButton = ({ fallbackPath = "/", onBack, forceFallback = false }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (forceFallback) {
      navigate(fallbackPath);
      return;
    }
    handleSmartBack(navigate, fallbackPath);
  };

  return (
    <>
      <p onClick={handleBack} className="mb-1 backlink">
        <i className="fa-solid fa-angle-left"></i> Back
      </p>
    </>
  );
};

export default BackButton;
